import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=05c1fd75&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=ts&"
export * from "./_slug.vue?vue&type=script&lang=ts&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=05c1fd75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1fd75",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsThePageTitleSection: require('/usr/src/nuxt-app/components/elements/ThePageTitleSection.vue').default,ElementsTheError: require('/usr/src/nuxt-app/components/elements/TheError.vue').default,ElementsTheSharer: require('/usr/src/nuxt-app/components/elements/TheSharer.vue').default})
